export default __webpack_public_path__ + "static/media/My130-1.a9746818.png";